// extracted by mini-css-extract-plugin
export default {"emojiInputContainer":"EmojiInput_emojiInputContainer__NNVPS","emojiContainer":"EmojiInput_emojiContainer__1Kja1"};